import { configureStore } from "@reduxjs/toolkit";
import  createProjectFormSlice from "./features/create-project/create-project-slice";
import createCompanySlice from "./features/create-company/create-company-slice";
import addParticipantsSlice from "./features/add-participants/add-participants-slice";
import setupMailSlice from "./features/setup-mail/setup-mail-slice";

export const store = configureStore({
    reducer : {
        createProjectForm :  createProjectFormSlice,
        createCompanyForm : createCompanySlice,
        addParticipants : addParticipantsSlice,
        setupMail : setupMailSlice,
    },
    devTools : process.env.NODE_ENV !== 'production',
})